/* eslint-disable semi */
/* eslint-disable comma-dangle */
// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { Fragment } from 'react'
import { Slide, toast } from 'react-toastify'

import baseurl from '../../../@core/auth/jwt/baseurl'
import emiter from '../../../utility/hooks/emiiter'

export const showErrorMsg = (error) => {
  toast.error(
    <Fragment>
      <div className="toastify-header">
        <div className="title-wrapper">
          <h6 className="toast-title fw-bold">Error</h6>
        </div>
      </div>
      <div className="toastify-body">
        <span>{error}</span>
      </div>
    </Fragment>,
    {
      icon: false,
      transition: Slide,
      hideProgressBar: false,
      autoClose: 2000
    }
  )
}

export const showSuccessMsg = (msg) => {
  toast.success(
    <Fragment>
      <div className="toastify-header">
        <div className="title-wrapper">
          <h6 className="toast-title fw-bold">Success</h6>
        </div>
      </div>
      <div className="toastify-body">
        <span>{msg}</span>
      </div>
    </Fragment>,
    {
      icon: false,
      transition: Slide,
      hideProgressBar: false,
      autoClose: 2000
    }
  )
}

export const getData = createAsyncThunk(
  'appDosageForm/getData',
  async (params) => {
    const response = await baseurl.get('/api/app/dosage-form', {
      params
    })
    return {
      params,
      data: response.data.items,
      total: response.data.totalCount
    }
  },
  {
    dispatchConditionRejection: true
  }
)

export const getById = createAsyncThunk(
  'appDosageForm/getById',
  async (id) => {
    try {
      const response = await baseurl.get(`/api/app/dosage-form/${id}`, {
        validateStatus: (status) => {
          return status >= 200 && status <= 500
        }
      })
      if (response.status === 200) {
        return response.data
      } else if (res.status === 403) {
        showErrorMsg(res.data.error.message)
      }
      return rejectWithValue(response.data)
    } catch (error) {
      return rejectWithValue(error)
    }
  },
  {
    dispatchConditionRejection: true
  }
)

export const addDosageForm = createAsyncThunk(
  'appDosageForm/addDosageForm',
  async (dosageform, { dispatch, getState, rejectWithValue }) => {
    try {
      const res = await baseurl.post('/api/app/dosage-form', dosageform, {
        validateStatus: (status) => {
          return status >= 200 && status <= 500
        }
      })
      if (res.status === 200) {
        showSuccessMsg('Added Successfully')
        emiter.emit('close-dosageform-add-or-edit-popup')
        await dispatch(getData(getState().dosageform.params))
        await dispatch(getById(res.data.id))
        return dosageform
      } else if (res.status === 403) {
        showErrorMsg(res.data.error.message)
      }
      return null
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const updateDosageForm = createAsyncThunk(
  'appDosageForm/updateDosageForm',
  async (dosageform, { dispatch, getState, rejectWithValue }) => {
    try {
      const res = await baseurl.put(`/api/app/dosage-form/${dosageform.id}`, dosageform, {
        validateStatus: (status) => {
          return status >= 200 && status <= 500
        }
      })
      if (res.status === 200) {
        showSuccessMsg('Updated Successfully')
        await dispatch(getData(getState().dosageform.params))
        await dispatch(getById(dosageform.id))
        return dosageform
      } else if (res.status === 403) {
        showErrorMsg(res.data.error.message)
      }
      return null
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const deleteDosageForm = createAsyncThunk(
  'appDosageForm/deleteDosageForm',
  async (id, { dispatch, getState, rejectWithValue }) => {
    try {
      const res = await baseurl.delete(`/api/app/dosage-form/${id}`, {
        validateStatus: (status) => {
          return status >= 200 && status <= 500
        }
      })
      if (res.status === 204) {
        emiter.emit('close-dosageform-delete-popup')
        await dispatch(getData(getState().dosageForm.params))
        return id
      } else if (res.status === 403) {
        showErrorMsg(res.data.error.message)
      }
      return null
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const initDosageForm = createAsyncThunk('appDosageForm/initDosageForm', (loading) => loading, {})

export const loadDosageFormtLookups = createAsyncThunk(
  'appDosageForm/loadDosageFormtLookups',
  async () => {
    const productionLineActivitiesResponse = await baseurl.get('/api/app/production-line-activity', {
      params: {
        MaxResultCount: 1000
      }
    })

    return {
      productionLineActivities: productionLineActivitiesResponse.data?.items
    }
  },
  {}
)

export const appDosageFormSlice = createSlice({
  name: 'appDosageForm',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedDosageForm: null,
    loading: true,
    getByIdLoading: false,
    saveLoading: false
  },
  reducers: {
    setUploads: (state, action) => {
      state.selectedDosageForm = {
        ...state.selectedDosageForm,
        uploads: action.payload
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getData.pending, (state) => {
        state.loading = true
      })
      .addCase(getData.rejected, (state) => {
        state.loading = false
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.total
        state.loading = false
      })

      .addCase(getById.pending, (state) => {
        state.getByIdLoading = true
        state.selectedDosageForm = null
      })
      .addCase(getById.rejected, (state) => {
        state.getByIdLoading = false
      })
      .addCase(getById.fulfilled, (state, action) => {
        state.getByIdLoading = false
        state.selectedDosageForm = action.payload
      })

      .addCase(addDosageForm.pending, (state) => {
        state.saveLoading = true
      })
      .addCase(addDosageForm.rejected, (state) => {
        state.saveLoading = false
      })
      .addCase(addDosageForm.fulfilled, (state) => {
        state.saveLoading = false
      })

      .addCase(updateDosageForm.pending, (state) => {
        state.saveLoading = true
      })
      .addCase(updateDosageForm.rejected, (state) => {
        state.saveLoading = false
      })
      .addCase(updateDosageForm.fulfilled, (state) => {
        state.saveLoading = false
      })

      .addCase(deleteDosageForm.pending, (state) => {
        state.deleteLoading = true
      })
      .addCase(deleteDosageForm.rejected, (state) => {
        state.deleteLoading = false
      })
      .addCase(deleteDosageForm.fulfilled, (state) => {
        state.deleteLoading = false
      })
      .addCase(initDosageForm.fulfilled, (state) => {
        state.selectedDosageForm = null
      })

    builder.addCase(loadDosageFormtLookups.fulfilled, (state, action) => {
      state.productionLineActivities = action.payload.productionLineActivities
    })
  }
})
export const { setUploads } = appDosageFormSlice.actions
export default appDosageFormSlice.reducer
